//
// Copyright (c) 2011-2026 by Curalate, Inc.
//

import {
  BazaarvoiceDestinationClient,
  BazaarvoiceDestinationsForSourceResponse,
  BazaarvoiceDestinationsRequest,
} from '@apis/campaign-requests/sampling/prepaid-campaigns/clientReviewSyndicatedEdgesApiModel';
import { makeParams } from '@utils/makeParams';
import { serializedGatewayFetch } from '@utils/sessionFetch';
import { ISerializedResponse } from '@utils/types/SerializedResponse';

const SHARE_BASE = '/api/v1/connect/bazaarvoice-network-relationships';

const syndicationGatewayFetch = (
  endpoint: string,
  init?: RequestInit,
): Promise<ISerializedResponse> =>
  serializedGatewayFetch(
    'syndication_gateway',
    `${SHARE_BASE}${endpoint}`,
    init,
  );

/**
 * Gets all destination clients for a given source client
 *
 * GET /api/v1/connect/bazaarvoice-network-relationships/:sourceClientId/destinations
 */
export const getBazaarvoiceDestinationsFromClient = async (
  req: BazaarvoiceDestinationsRequest,
  init?: RequestInit,
): Promise<BazaarvoiceDestinationClient[]> => {
  const params = makeParams({
    edgeContentTypes: req.edgeContentTypes,
  });

  const res = await syndicationGatewayFetch(
    `/${req.sourceClientId}/destinations?${params}`,
    { ...init, method: 'GET' },
  );

  const { clients } =
    await res.json<BazaarvoiceDestinationsForSourceResponse>();

  return clients;
};
